module.exports = __webpack_public_path__ + "static/media/speedmeter.69938956.svg";